// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '@coa/app/core/services/config.service';
import { DashboardGroupsFilters } from '@coa/app/home/modules/dashboard/modules/dashboard-groups/models/dashboard-groups-filters';
import { DashboardGroupsResponse } from '@coa/app/home/modules/dashboard/modules/dashboard-groups/models/dashboard-groups-response';

@Injectable({
  providedIn: 'root',
})
export class DashboardGroupsService {

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  getGroups(filters: DashboardGroupsFilters): Observable<DashboardGroupsResponse> {
    const url = `${ this.configService.getConfig().analyticsApi }/dynamic-groups`;
    const properties = [
      'clientId',
      'timePeriod',
      'sortingKey',
      'sortingDirection',
      'categoryId',
      'name',
      'size',
      'page',
    ];
    const params = this.buildParams(filters, properties);
    return this.httpClient.get<DashboardGroupsResponse>(url, {params});
  }

  private buildParams(paramsObject: DashboardGroupsFilters, properties: string[]): HttpParams {
    let params = new HttpParams();
    properties.forEach((property) => {
      if (paramsObject[property] != null) {
        params = params.set(property, paramsObject[property].toString());
      }
    });

    return params;
  }
}
